import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TradePairFacade, TradePairState } from '../store/bottradepair';

@Injectable({
    providedIn: 'root'
})

export class adminHanumanUpsideService {
    constructor(
        private http: HttpClient,
        private tradePairFacade: TradePairFacade
    ) { }


    getPairList() {
        return this.http.get(environment.hanumanUpsideApiUrl + 'api/bot/tradePair')
    }
    getBotCount(params: any) {
        return this.http.get(environment.hanumanUpsideApiUrl + 'api/bot/getBotCount', { params })
    }
    botValidation(payload: any) {
        return this.http.post(environment.hanumanUpsideApiUrl + 'api/bot/bot-validation', payload)
    }
    getBotHistory(payload: any) {
        return this.http.post(environment.hanumanUpsideApiUrl + 'api/bot/getBotHistory', payload)
    }
    getBotProfit() {
        return this.http.get(environment.hanumanUpsideApiUrl + 'api/bot/getBotPofit')
    }
    getActiveBotByPair(params: any) {
        return this.http.get(environment.hanumanUpsideApiUrl + 'api/bot/getBotPofit', { params })
    }
    getPositionHistory(payload: any) {
        return this.http.post(environment.hanumanUpsideApiUrl + 'api/bot/getPositionDetials', payload)
    }
    getOpenOrders(payload: any) {
        return this.http.post(environment.hanumanUpsideApiUrl + 'api/bot/getOpenOrders', payload)
    }
    getOrderHistory(payload: any) {
        return this.http.post(environment.hanumanUpsideApiUrl + 'api/bot/getOrderHistory', payload)
    }
    closeBot(payload: any) {
        return this.http.post(environment.hanumanUpsideApiUrl + 'api/bot/close-bot', payload)
    }
    pauseBot(payload: any) {
        return this.http.post(environment.hanumanUpsideApiUrl + 'api/bot/pause-bot', payload)
    }
    cancelAndWait(payload: any) {
        return this.http.post(environment.hanumanUpsideApiUrl + 'api/bot/cancel-limit-and-wait', payload)
    }
    getOpenOChart(payload: any) {
        return this.http.post(environment.hanumanUpsideApiUrl + 'api/bot/getOpenOrdersChart', payload)
    }
    orderPlace(payload: any) {
        return this.http.post(environment.hanumanUpsideApiUrl + 'api/bot/orderplace', payload)
    }
    download(payload: any) {
        return this.http.post(environment.hanumanUpsideApiUrl + `api/bot/download-cvs`, payload, {
            responseType: 'blob', observe: 'events',
            reportProgress: true
        })
    }
    downloadOpportunity(payload: any) {
        return this.http.post(environment.hanumanUpsideApiUrl + `api/bot/download-opportunity`, payload, {
            responseType: 'blob', observe: 'events',
            reportProgress: true
        })
    }
    blockBot() {
        return this.http.get(environment.hanumanUpsideApiUrl + 'api/bot/get-last-order')
    }
    getRecentTrade(params: any) {
        return this.http.get(environment.hanumanUpsideApiUrl + `api/bot/recentTrade/${params}`)
    }
    getOrderBook(pairId: string) {
        return this.http.get(environment.hanumanUpsideApiUrl + `api/bot/ordeBook/${pairId}`)
    }
    getOpportunityHistory(payload: any) {
        return this.http.post(environment.hanumanUpsideApiUrl + 'api/bot/get-opportunity', payload)
    }

    setTradePair({
        firstCurrencySymbol,
        firstCurrencyId,
        firstFloatDigit,
        secondCurrencySymbol,
        secondCurrencyId,
        secondFloatDigit,
        botstatus,
        tikerRoot,
        _id,
        maker_rebate,
        taker_fees
    }: TradePairState) {
        this.tradePairFacade.setTradePair(
            {
                firstCurrencySymbol,
                firstCurrencyId,
                firstFloatDigit,
                secondCurrencySymbol,
                secondCurrencyId,
                secondFloatDigit,
                botstatus,
                tikerRoot,
                _id,
                maker_rebate,
                taker_fees
            })
    }



}
